import { aboutHero } from '@/mocks/aboutData';
import { img, readdy } from '@/utils/images';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function AboutHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={readdy('about-hero-001')}
          alt="品牌总部"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6 md:px-10">
        <ScrollReveal variant="fade-down">
          <p className="text-white/60 text-xs md:text-sm tracking-[0.3em] mb-4 font-medium uppercase">
            {aboutHero.subtitle}
          </p>
        </ScrollReveal>
        <ScrollReveal variant="fade-up" delay={100}>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {aboutHero.title}
          </h1>
        </ScrollReveal>
        <ScrollReveal variant="fade-up" delay={200}>
          <p className="text-white/70 text-sm md:text-base max-w-2xl leading-relaxed">
            {aboutHero.description}
          </p>
        </ScrollReveal>
        <ScrollReveal variant="fade-up" delay={350}>
          <div className="flex items-center gap-2 mt-8 text-white/50 text-xs">
            <span>麦杰集团</span>
            <span className="w-1 h-1 rounded-full bg-white/30" />
            <span>健康纤体连锁品牌</span>
            <span className="w-1 h-1 rounded-full bg-white/30" />
            <span>十余年行业积淀</span>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}